import React from 'react';

export default function ContentTab({ adoption }) {
  const groups = adoption?.by_asset_type || {};
  const keys = Object.keys(groups);
  return (
    <div className="space-y-6" data-testid="governance-content">
      {keys.length === 0 && <div className="text-slate-500 text-sm">No content data yet.</div>}
      {keys.map(k => (
        <div key={k}>
          <h4 className="text-sm font-semibold text-slate-700 dark:text-slate-300 mb-2 capitalize">{k.replace(/_/g, ' ')}s</h4>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div className="rounded-lg border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-900/50">
              <div className="px-3 py-2 text-xs uppercase text-emerald-600 border-b border-slate-100 dark:border-slate-800">Top viewed</div>
              {(groups[k]?.top || []).length === 0 ? (
                <div className="p-4 text-sm text-slate-400">No data</div>
              ) : (
                <ul className="text-sm divide-y divide-slate-100 dark:divide-slate-800">
                  {(groups[k].top || []).map(a => (
                    <li key={a.object_id} className="px-3 py-2 flex justify-between">
                      <span className="truncate mr-3">{a.object_name || a.object_id}</span>
                      <span className="text-slate-500 tabular-nums">{a.view_count || 0}</span>
                    </li>
                  ))}
                </ul>
              )}
            </div>
            <div className="rounded-lg border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-900/50">
              <div className="px-3 py-2 text-xs uppercase text-amber-600 border-b border-slate-100 dark:border-slate-800">Least viewed</div>
              {(groups[k]?.bottom || []).length === 0 ? (
                <div className="p-4 text-sm text-slate-400">No data</div>
              ) : (
                <ul className="text-sm divide-y divide-slate-100 dark:divide-slate-800">
                  {(groups[k].bottom || []).map(a => (
                    <li key={a.object_id} className="px-3 py-2 flex justify-between">
                      <span className="truncate mr-3">{a.object_name || a.object_id}</span>
                      <span className="text-slate-500 tabular-nums">{a.view_count || 0}</span>
                    </li>
                  ))}
                </ul>
              )}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
